import styled from 'styled-components';

const SectionWrapper = styled.section`
  padding: 60px 0;
  background-color: #ffffff;
  @media (max-width: 768px) {
    padding: 40px 0;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 40px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 2px;

  @media (max-width: 768px) {
    font-size: 20px;
    margin-bottom: 30px;
  }
`;

export const LogoGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 40px;
  width: 100%;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

export const LogoItem = styled.div`
  flex: 0 1 calc(20% - 40px);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
  opacity: 0.9;

  &:hover {
    opacity: 1;
    transform: translateY(-5px);
  }

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  img {
    max-width: 160px;
    max-height: 80px;
    width: auto;
    height: auto;
    object-fit: contain;
  }

  @media (max-width: 992px) {
    flex: 0 1 calc(33.33% - 40px);
  }

  @media (max-width: 768px) {
    flex: 0 1 calc(50% - 20px);
    img {
        max-width: 120px;
        max-height: 60px;
    }
  }
`;

export default SectionWrapper;
